<template>
  <div>
    <div class="vz-order-view-blocks-title text-h1 mb-20">
      Участники
    </div>

    <div class="vz-order-view-blocks">
      <vz-customer-view
        type="dispatch"
        :order="localOrder"
      />
      <vz-customer-view
        v-if="!isNetwork"
        type="destination"
        :order="localOrder"
      />
      <vz-customer-view
        v-if="thirdVisible"
        type="third"
        :order="localOrder"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useOrderStore } from '~/stores/order';
import VzCustomerView from '~/components/personal/order/vz-order-view/customer/vz-customer-view.vue'
import {PropType} from 'vue';
import {OrderForm} from '~/types/types';

const props = defineProps({
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  },
})

const { orderView } = storeToRefs(useOrderStore())

const localOrder = computed(() => {
  return props.order?.customer ? props.order : orderView.value
})

const isNetwork = computed((): boolean => {
  return localOrder.value.isNetwork || false
})

const thirdVisible = computed((): boolean => {
  if (localOrder.value.customer?.third?.type === 'individual') {
    return !!localOrder.value.customer?.third[localOrder.value.customer?.third?.type]?.name?.id ||
      !!localOrder.value.customer?.third[localOrder.value.customer?.third?.type]?.name?.value
  } else {
    return !!localOrder.value.customer?.third[localOrder.value.customer?.third?.type]?.name ||
      !!localOrder.value.customer?.third[localOrder.value.customer?.third?.type]?.name
  }
})
</script>

<style lang="scss">

</style>
